// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Stack,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  MenuButton,
  SingleSelect,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../hooks/useIntl';
import generalMessages from '../../App/messages';
import parentMessages from '../messages';
import messages from './messages';

type GrossRentCertificationsToolbarProps = {
  handleMenuItemClick: (value: string) => void,
  isMenuDisabled: boolean,
  menuDisabledTooltip?: string,
  isSubmittingComplete: boolean,
  isSubmittingGenerateAll: boolean,
  menuOptions: Array<{
    value: string,
    text: string,
    disabled?: boolean,
    tooltip?: string,
  }>,
  onEffectiveDateChange: (value: string) => void,
  selectOptions: Array<{ value: string, text: string }>,
  selectedEffectiveDate: string,
};

const GrossRentCertificationsToolbar = ({
  handleMenuItemClick,
  isMenuDisabled,
  menuDisabledTooltip,
  isSubmittingComplete,
  isSubmittingGenerateAll,
  menuOptions,
  onEffectiveDateChange,
  selectOptions,
  selectedEffectiveDate,
}: GrossRentCertificationsToolbarProps) => {
  const intl = useIntl();
  const isEffectiveDateDisabled = selectOptions.length === 0;
  const isSubmittingMenuActions =
    isSubmittingGenerateAll || isSubmittingComplete;

  const menuButtonSx = {
    bgcolor: 'common.white',
    minWidth: { xs: 0, sm: 175 },
    mr: { xs: 0, sm: 1 },
    px: '16px',
    py: '10px',
    width: { xs: '100%', sm: 'auto' },
  };

  const menuButton = (
    <MenuButton
      variant="shoutSubtle"
      disabled={isMenuDisabled}
      onMenuItemClick={handleMenuItemClick}
      options={menuOptions}
      submitButton={false}
      ButtonProps={{
        isSubmitting: isSubmittingMenuActions,
      }}
      sx={menuButtonSx}
    >
      <FormattedMessage {...parentMessages.header} />
    </MenuButton>
  );

  const menuButtonWithTooltip = isMenuDisabled ? (
    <Tooltip title={menuDisabledTooltip ?? ''} placement="top" variant="light">
      <span style={{ display: 'block', width: '100%' }}>{menuButton}</span>
    </Tooltip>
  ) : (
    menuButton
  );

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}
      justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
      spacing={{ xs: 1, sm: 0 }}
      width="100%"
    >
      <SingleSelect
        name="grossRentCertificationsEffectiveDate"
        label={intl.formatMessage(messages.effectiveDateLabel)}
        options={selectOptions}
        value={selectedEffectiveDate}
        onChange={onEffectiveDateChange}
        disabled={isEffectiveDateDisabled}
        placeholder={intl.formatMessage(generalMessages.tripleDash)}
        displayEmpty
        fullWidth={false}
        helperText={null}
        HelperTextProps={{ sx: { display: 'none' } }}
        sx={{ width: { xs: '100%', sm: 200 }, margin: 0 }}
      />
      {menuButtonWithTooltip}
    </Stack>
  );
};

export default GrossRentCertificationsToolbar;
